'use client';

import { useMemo } from 'react';
import { useSearchParams } from 'next/navigation';

import MysteryRoomMapGate from '@/components/games/mystery-room/MysteryRoomMapGate';
import { parseMysteryRoomChallengeParams } from '@/lib/games/mysteryRoom/engine';

export default function MysteryRoomPage() {
  const searchParams = useSearchParams();
  const challenge = useMemo(() => parseMysteryRoomChallengeParams(searchParams), [searchParams]);

  return (
    <div className="h-screen overflow-hidden bg-[radial-gradient(circle_at_top,#1e293b_0%,#09090b_40%,#020617_100%)]">
      <MysteryRoomMapGate challenge={challenge} />
    </div>
  );
}
